const AIDesk = {
  "结束会话": "Finalizar conversación",
  "转人工服务": "Transferir a un agente",
  "跳转": "Abrir",
  "立即填写": "Completar ahora",
  "已提交": "Enviado",
  "提交": "Enviar",
  "查看内容": "Ver contenido",
  "请填写必填项": "Por favor, complete los campos obligatorios",
  "请输入内容":"Por favor, introduzca el contenido",
  "如果满意请给好评哦～":"Si está satisfecho, por favor, deje una buena valoración~",
  "请对本次服务进行评价": "Por favor, valore este servicio",
  "提交评价": "Valoración del servicio",
  "并发限制": "En este momento hay demasiados usuarios accediendo al servicio. Por favor, inténtelo de nuevo más tarde",
  "分支选项异常": "El contenido es anómalo, por favor verifique la configuración del flujo de tareas",
  "服务评价": "Valoración del servicio",
  "满意": "Satisfecho",
  "不满意": "Insatisfecho",
  "感谢您的反馈，我们会持续优化改进": "Gracias por sus comentarios, seguiremos mejorando",
  "您遇到了哪方面的问题": "¿Qué problema encontró?",
  "其他反馈内容": "Otros comentarios",
  "取消": "Cancelar",
  "答非所问": "Respuesta irrelevante",
  "未匹配相关内容": "No se encontró contenido relacionado",
  "信息错误": "Información incorrecta",
  "上下文理解错误": "Malentendido del contexto",
  "格式不规范": "Formato incorrecto",
  "内容不完整": "Contenido incompleto",
  "file 大小超过 100MB，无法发送": "No se puede enviar el archivo porque supera los 100 MB",
  "image 大小超过 20MB，无法发送": "No se puede enviar la imagen porque supera los 20 MB",
  "video 大小超过 100MB，无法发送": "No se puede enviar el video porque supera los 100 MB",
  "提交成功": "Enviado con éxito",
  "userID 只能包含可打印 ASCII 字符": "El userID solo puede contener caracteres ASCII imprimibles",
  "userID 不能包含'administrator'": "El userID no puede contener la cadena 'administrator'",
  "userID 长度不能超过45字节": "La longitud del userID no puede exceder los 45 bytes",
  "我们想知道你对此回答不满意的原因，你认为更好的回答是什么？": "Agradecemos su opinión. Por favor, comparta cualquier sugerencia para ayudarnos a mejorar.",
  "该回复由AI生成，内容仅供参考": "Contenido generado por IA",
  "排队等待中": "En cola",
  "排队等待话术": "Disculpe la espera. Todos los agentes están atendiendo a otros clientes. Se le conectará en breve. Gracias por su paciencia.",
  "当前前方排队人数": "Posición en la cola",
  "结束排队": "Salir de la cola",
  "评价提交超过3分钟，无法更改。感谢您的反馈！": "Una valoración enviada hace más de 3 minutos no puede modificarse.",
  "不能发送空白消息": "No se puede enviar un mensaje vacío",
  "确认转人工": "Confirmar transferencia a agente",
}
export default AIDesk;